<template>
    <main class="mt-5">
        <div class="card mt-3">
            <div class="card-header  border-0">
                <h5 class="card-title font-bold py-3">گزارش کلی عملکرد فروشندگان</h5>
                <div style="flex: 1"></div>
                <Back url="/admin/sales-management" />
            </div>
            <div class="row px-4 not-in-print">
                <form autocomplete="new-password" @submit.prevent="doFilter"
                    class="col-12 d-flex justify-content-center align-items-center">

                    <div class="me-2">
                        <DatePickerRange v-model="filterDate" />
                    </div>

                    <button :disabled="disabled" type="submit" class="btn btn-info mr-5">
                        اعمال فیلتر
                    </button>

                </form>
            </div>
            <div class="d-flex my-4 mr-2-print px-5">
                <span class="ml-1 font-bold">گزارش کلی عملکرد فروشندگان</span>
                <div v-if="filterDate.startDate">
                    <span>از</span>
                    <span class="font-weight-bold mx-1">تاریخ</span><span> {{ filterDate.startDate | persianDate }}
                    </span>
                </div>
                <div class="mr-3" v-if="filterDate.endDate">
                    <span>تا</span>
                    <span class="font-weight-bold mx-1">تاریخ</span><span> {{ filterDate.endDate | persianDate }}
                    </span>
                </div>
            </div>
            <Loading class="mb-5" v-if="loading" />
            <div class="row justify-content-center text-center mb-3 g-3" v-else-if="reports && reports.length">

                <div v-for="item in reports" :key="item.id" class="col-12">

                    <b>تاریخ: {{ item.start_date | persianDate }}</b>

                    <div class="row justify-content-center text-center g-3 mt-2">

                        <div class="col-12 col-md-auto d-flex justify-content-center">
                            <router-link :to="`/admin/sales-management/reports/result-goods-sellers?start_date=${item.start_date}&end_date=${item.end_date}`">
                                <div class="report-item-card">
                                    <span class="report-label">ارسالی :</span>
                                    <span class="report-label">{{ item.sent }}</span>
                                </div>
                            </router-link>
                        </div>

                        <div class="col-12 col-md-auto d-flex justify-content-center">
                            <router-link :to="`/admin/sales-management/reports/result-goods-sellers?start_date=${item.start_date}&end_date=${item.end_date}`">
                                <div class="report-item-card">
                                    <span class="report-label">فروش رفته :</span>
                                    <span class="report-label">{{ item.sold }}</span>
                                </div>
                            </router-link>
                        </div>

                        <div class="col-12 col-md-auto d-flex justify-content-center">
                            <router-link :to="`/admin/sales-management/reports/result-goods-sellers?start_date=${item.start_date}&end_date=${item.end_date}`">
                                <div class="report-item-card">
                                    <span class="report-label">برگشت داده شده :</span>
                                    <span class="report-label">{{ item.returned }}</span>
                                </div>
                            </router-link>
                        </div>

                        <div class="col-12 col-md-auto d-flex justify-content-center">
                            <router-link :to="`/admin/sales-management/reports/result-goods-sellers?start_date=${item.start_date}&end_date=${item.end_date}`">
                                <div class="report-item-card">
                                    <span class="report-label">مانده :</span>
                                    <span class="report-label">{{ item.unknown }}</span>
                                </div>
                            </router-link>
                        </div>

                        <div class="col-12 col-md-auto d-flex justify-content-center">
                            <router-link :to="`/admin/sales-management/reports/result-goods-sellers?start_date=${item.start_date}&end_date=${item.end_date}`">
                                <div class="report-item-card">
                                    <span class="report-label">بررسی شده :</span>
                                    <span class="report-label">{{ item.checked }}</span>
                                </div>
                            </router-link>
                        </div>

                        <div class="col-12">
                            <hr>
                        </div>

                    </div>

                </div>

            </div>

            <p v-else class="row justify-content-center mb-3 g-3">داده‌ای یافت نشد.</p>
        </div>
    </main>
</template>

<script>
import { BTooltip, BFormGroup, BFormInput, BFormCheckbox, BTd, VBToggle, VBTooltip } from "bootstrap-vue";
import DatePickerRange from "@@/core/components/shared/DatePickerRange/DatePickerRange";
import mixins from '@@/core/mixins/mixins'
import Loading from '@@/core/components/shared/Loading/Loading'
import Back from "@@/core/components/shared/Back/Back";

function Filter() {
    this.date = {
        startDate: "",
        endDate: "",
    };
}

Filter.prototype.set = function (filters) {
    Object.entries(filters).forEach(([index, value]) => {
        this[index] = value;
    });
};

export default {
    name: "ResultGoods",
    mixins: [mixins],
    components: {
        DatePickerRange,
        Loading,
        BFormCheckbox,
        BFormGroup,
        BTooltip,
        Back,
        BTd,
        BFormInput,
    },
    directives: {
        'b-toggle': VBToggle, 'b-tooltip': VBTooltip,
    },
    data() {
        return {
            disabled: true,
            search: "",
            to_id: "",
            loading: false,
            from_id: "",
            reports: null,
            filterDate: {
                endDate: "",
                startDate: "",
            },
        };
    },
    created() {
        this.loadData();
    },
    methods: {
        print() {
            window.print();
        },
        doFilter() {
            this.reports = null;
            this.disabled = true;
            this.$route.query.start_date = null;
            this.$route.query.end_date = null;
            this.loadData();
        },
        formatDate(date) {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');
            const seconds = String(date.getSeconds()).padStart(2, '0');
            return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        },
        async loadData() {
            this.loading = true;
            this.reports = null;

            if (this.$route.query.start_date && this.$route.query.end_date) {
                this.filterDate.startDate = this.$route.query.start_date;
                this.filterDate.endDate = this.$route.query.end_date;
            } else{
                const today = new Date();
                const startOfToday = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0);
                
                if (!this.filterDate.startDate || !this.filterDate.endDate) {
                    this.filterDate.startDate = this.formatDate(startOfToday);
                    this.filterDate.endDate = this.formatDate(today);
                }
            }
            
            try {
                const response = await this.$axios.get("admin/sellers-transaction-reports/list-by-requests", {
                    params: {
                        start_date: this.filterDate.startDate,
                        end_date: this.filterDate.endDate,
                    },
                });

                this.reports = response.data.data.result.map(item => {
                    const dateStr = item.date;

                    const start = `${dateStr} 00:00`;
                    const end = `${dateStr} 23:59`;

                    return {
                        ...item,
                        start_date: start,
                        end_date: end
                    };
                });
                this.disabled = false;
                console.log(this.disabled,'this.disabled');
                
            } catch (e) {
                this.reports = [];
            }

            this.loading = false;
        },
    },
    computed: {
    },
};
</script>

<style scoped>
.report-item-card {
    position: relative;
    overflow: hidden;
    width: 300px;
    max-width: 100%;
    padding: 18px 15px;
    border-radius: 16px;
    background: linear-gradient(35deg, #d1b668cf, #acbed596);
    border: 1px solid #e5e9f0;
    display: flex;
    margin-bottom: 15px;
    justify-content: space-between;
    align-items: center;
    gap: 13px;
    transition: 0.5s ease;
    box-shadow: 0 3px 8px rgba(0, 0, 0, 0.05);
}

.report-item-card::before {
    content: "";
    position: absolute;
    inset: 0;
    background: linear-gradient(127deg, #3e40406b, #acbed57a);
    transform: translateX(100%);
    transition: transform 0.45s ease;
    z-index: 0;
}

.report-item-card:hover::before {
    transform: translateX(0);
}

.report-item-card * {
    position: relative;
    z-index: 1;
}

.report-label {
    font-weight: 600;
    font-size: 15px;
    color: #2b2b2b;
    white-space: nowrap;
}
</style>
<style>
.print-only {
    display: none;
}

@media print {
    .not-in-print {
        display: none !important;
    }

    .app-content .side-app {
        padding: 0 !important;
    }

    body * {
        visibility: hidden;
    }

    .print-only {
        display: flex;
        justify-content: center;
    }

    #print,
    #print * {
        visibility: visible;
        font-size: 1.25rem;
    }

    #print {
        padding: 0 !important;
        width: 100%;
    }

    .mr-2-print {
        margin-right: 20px;
    }
}
</style>